;
define("product_list_control.tpl", function(){});

